import React from 'react'
import { ConfirmationDialog } from '../../legacy-design-system/modal'
import { useIntl } from 'react-intl'

interface BlockAtPerimeterDialogProps {
  readonly onConfirm: () => void
  readonly onCancel: () => void
  readonly isOpen: boolean
}

export function BlockAtPerimeterDialog({
  onCancel,
  onConfirm,
  isOpen
}: BlockAtPerimeterDialogProps) {
  const { formatMessage } = useIntl()

  const title = formatMessage({
    id: 'title_ruleModeBlockAtPerimeter'
  })
  const description = formatMessage({
    id: 'detail_blockAtPerimeterDialog'
  })
  const confirmMsg = formatMessage({
    id: 'action_applicationExclusion_blockAtPerimeter'
  })
  const cancelMsg = formatMessage({
    id: 'action_cancel'
  })

  return (
    <ConfirmationDialog
      size="medium"
      isOpen={isOpen}
      onCancel={onCancel}
      onConfirm={onConfirm}
      renderTitle={() => title}
      renderBody={() => description}
      renderConfirmMessage={() => confirmMsg}
      renderCancelMessage={() => cancelMsg}
    />
  )
}
